import { Box, Typography } from '@coolblue-development/becky';
import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';

interface ReplyHeaderProps {
  data: EmailContactData;
}

const ReplyHeader = ({ data }: ReplyHeaderProps): JSX.Element => {
  return (
    <Box
      sx={{
        border: '1px solid #DDDDDD',
        borderRadius: '4px 4px 0 0',
        padding: '12px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        data-testid="reply-header"
      >
        {data.subject && (
          <Typography
            variant="h6"
            sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}
            data-testid="reply-subject"
          >
            {data.subject}
          </Typography>
        )}
        <CopyContactIdButton contactId={data.contactId} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {data.from && (
          <Typography variant="subtitle2" color="textSecondary" data-testid="reply-to">
            To: {data.from}
          </Typography>
        )}
        <Typography variant="subtitle2" color="textSecondary" data-testid="reply-cc">
          Cc:
        </Typography>
      </Box>
    </Box>
  );
};

export default ReplyHeader;
